import React from 'react'

import { FaMapMarkerAlt } from "react-icons/all";

export const MapMarker: React.FC<{ lat: number; lng: number; text: string; aqi: number; pm25?: string | number | null; selected?: boolean, onClick?: () => void }> =
  ({ text, selected, aqi, pm25, onClick }) => {
    const pm25Value =
      pm25 === null || pm25 === undefined || pm25 === "" ? NaN : Number(pm25);
    const pm25Text = isNaN(pm25Value) ? "N/A" : String(pm25);

    return (
      <>
        <div
          className="hover:text-gray-800 text-transparent font-bold hover:shadow-lg text-center"
          title={`PM 2.5 Average: ${pm25Text}${isNaN(pm25Value) ? "" : " µg/m³"}`}
          onClick={onClick}
        >
          {/* sized box so the badge and the blinking ring stay exactly the same
              circle, and so the circle is centred on the device coordinates */}
          <div className="relative w-12 h-12 -ml-6 -mt-6">
            <span
              className={`absolute inset-0 rounded-full bg-transparent border-2 text-gray-200 border-white ${
                !!selected ? "animate-ping" : ""
              }`}
            ></span>
            <div className="relative flex flex-row justify-center items-center z-10 rounded-full w-12 h-12 bg-green-600 text-gray-200 border-2 border-white text-xs leading-none whitespace-nowrap">
              {pm25Text}
            </div>
          </div>
          {text}
        </div>
      </>
    );
  };

export const MapMarkerMemoized = React.memo(MapMarker);
